export const enum Path {
  LOGIN = '/login',
  REGISTER = '/register',
  DASHBOARD = '/dashboard',
  CALENDAR = '/calendar',
  EXPLORER = '/explorer',
  LANDING_PAGE = '/landing-page',
  CTF = '/ctf',
  CTF_RESULTS = '/ctf-results',
}
